
export function splitArrayToChunks<T>(originalArray: T[], chunkSize: number): Array<T[]> {

  if(!originalArray || originalArray.length === 0) {
    return [];
  }

  let result: Array<T[]> = [];
  for(let i = 0; i * chunkSize < originalArray.length; i++) {
    result.push(originalArray.slice(i * chunkSize, i * chunkSize + chunkSize));
  }

  return result;
}

export function arraysEqual<T>(arr1: T[], arr2: T[]) {
  if (arr1 === arr2) return true;
  if (arr1 == null || arr2 == null) return false;
  if (arr1.length !== arr2.length) return false;

  for (let i = 0; i < arr1.length; ++i) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
}

/**
 * Shuffle an array using the Fisher-Yates unbiased algorithm
 * Read more about the algorithm here: https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
 * The implementation is taken from here: https://bost.ocks.org/mike/shuffle/
 * and updated a bit for typescript
 */
export function shuffle(array: unknown[]) {
  let m = array.length, t: unknown;

  // While there remain elements to shuffle…
  while (m) {

    // Pick a remaining element…
    let i = Math.floor(Math.random() * m--);

    // And swap it with the current element.
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}
